<script setup lang="ts">
// Session rehydration is owned by the router's `beforeEach` guard so the
// router never sees a stale `isAuthenticated === false` while `/auth/me.php`
// is still in flight on hard refresh. Do NOT also call it here — concurrent
// invocations used to race the guard and bounce the user back to /login.
</script>

<template>
  <router-view />
</template>
